module.exports = __webpack_public_path__ + "static/media/BannerImage.8713892c.png";